export default {
  accessory: "mdi-view-grid-plus",
  accounting: "mdi-calculator-variant",
  account: "mdi-bank",
  account_payable: "mdi-bank-transfer-out",
  account_receivable: "mdi-bank-transfer-in",
  ack: "mdi-text-box-check-outline",
  add: "mdi-plus",
  add_circle: "mdi-plus-circle",
  add_image: "mdi-image-plus",
  address: "mdi-map-marker",
  admin: "mdi-shield-account",
  ai: "mdi-robot",
  archive: "mdi-archive",
  arrow_back: "mdi-arrow-left",
  arrow_left: "mdi-arrow-left",
  arrow_down: "mdi-arrow-down",
  arrow_drop_down: "mdi-menu-down",
  arrow_right: "mdi-arrow-right",
  arrow_up: "mdi-arrow-up",
  attachment: "mdi-attachment",
  available: "mdi-check-bold",
  awaiting_payment: "mdi-cash-clock",
  backorder: "mdi-calendar-alert",
  bank: "mdi-bank",
  barcode: "mdi-barcode-scan",
  bill: "mdi-text-box",
  billing: "mdi-currency-usd",
  birthdate: "mdi-cake-variant",
  browse_files: "mdi-folder-open",
  bug: "mdi-bug",
  bullet: "mdi-circle-small",
  bypass: "mdi-fast-forward",
  calendar: "mdi-calendar-blank",
  calendar_add: "mdi-calendar-plus",
  calendar_agenda: "mdi-view-agenda",
  calendar_day: "mdi-view-day",
  calendar_month: "mdi-calendar-month",
  calendar_scheduler: "mdi-chart-timeline",
  calendar_week: "mdi-view-week",
  camera: "mdi-camera",
  camera_off: "mdi-camera-off",
  cancel: "mdi-close-thick",
  cash: "mdi-cash",
  category: "mdi-shape",
  category_outline: "mdi-shape-outline",
  cellphone: "mdi-cellphone",
  change_order: "mdi-file-document-edit",
  change_request: "mdi-comment-edit",
  check: "mdi-check-bold",
  check_all: "mdi-check-all",
  check_circle: "mdi-check-circle",
  cheque: "mdi-checkbook",
  chevron_down: "mdi-chevron-down",
  chevron_left: "mdi-chevron-left",
  chevron_right: "mdi-chevron-right",
  chevron_up: "mdi-chevron-up",
  children: "mdi-account-child",
  clear: "mdi-close-circle",
  close: "mdi-window-close",
  closed: "mdi-check-decagram",
  code: "mdi-code-tags",
  clearsum: "mdi-plus-circle",
  collapse_row: "mdi-arrow-collapse-vertical",
  columns: "mdi-view-column",
  commission: "mdi-sack-percent",
  commission_split: "mdi-account-multiple",
  compare: "mdi-compare-horizontal",
  company: "mdi-account-group",
  contact: "mdi-account",
  contact_group: "mdi-account-question-outline",
  contact_info: "mdi-phone-message",
  contact_multiple: "mdi-account-multiple",
  contact_remove_multiple: "mdi-account-multiple-remove",
  contacts: "mdi-contacts",
  contract: "mdi-handshake",
  contractor: "mdi-hard-hat",
  conversation: "mdi-forum",
  copy: "mdi-content-copy",
  cost: "mdi-cash-minus",
  credit_card: "mdi-credit-card",
  credit_memo: "mdi-credit-card-refund-outline",
  customer: "mdi-account-box",
  damage: "mdi-flash-alert",
  dark_mode: "mdi-invert-colors",
  dashboard: "mdi-view-dashboard",
  date: "mdi-calendar",
  date_done: "mdi-calendar-check",
  date_estimate: "mdi-calendar-question",
  date_time: "mdi-calendar-clock",
  decline: "mdi-close-thick",
  delete: "mdi-delete",
  delete_all: "mdi-delete-sweep",
  delivered: "mdi-truck-check",
  delivering: "mdi-truck-fast-outline",
  delivery: "mdi-truck",
  deposit: "mdi-bank-transfer-in",
  description: "mdi-note-text",
  designer: "mdi-draw",
  directions: "mdi-directions",
  direct_ship: "mdi-truck-fast",
  discount: "mdi-currency-usd-off",
  donated: "mdi-gift",
  done: "mdi-check-bold",
  done_all: "mdi-check-all",
  door: "mdi-door",
  download: "mdi-download",
  drag: "mdi-drag-vertical",
  draw_amount: "mdi-cash-minus",
  drop_off: "mdi-map-marker-plus",
  due_date: "mdi-calendar-alert",
  duplicate: "mdi-content-duplicate",
  edit: "mdi-pencil",
  edit_off: "mdi-pencil-off",
  email: "mdi-email",
  email_fail: "mdi-email-remove",
  email_multiple: "mdi-email-multiple",
  email_success: "mdi-email-check",
  email_sync: "mdi-email-sync",
  equipment_rental: "mdi-forklift",
  error: "mdi-alert-circle",
  event: "mdi-calendar",
  expand_row: "mdi-arrow-expand-vertical",
  expense: "mdi-cash-minus",
  export: "mdi-file-export",
  fax: "mdi-fax",
  fee: "mdi-cash-register",
  feedback: "mdi-message-processing",
  file_upload: "mdi-file-upload-outline",
  fix: "mdi-wrench",
  file: "mdi-file",
  file_csv: "mdi-file-table",
  file_doc: "mdi-file-document",
  file_docx: "mdi-file-document",
  file_jpg: "mdi-file-image",
  file_jpeg: "mdi-file-image",
  file_mov: "mdi-file-video",
  file_mp4: "mdi-file-video",
  file_pdf: "mdi-file-pdf-box",
  file_png: "mdi-file-image",
  file_svg: "mdi-file-image",
  file_txt: "mdi-file-document",
  file_type: "mdi-file-question",
  file_webp: "mdi-file-image",
  file_xml: "mdi-file-code",
  file_zip: "mdi-folder-zip",
  filter: "mdi-filter",
  filter_empty: "mdi-filter-outline",
  filter_empty_off: "mdi-filter-off-outline",
  filter_off: "mdi-filter-off",
  first: "mdi-page-first",
  fixed_asset: "mdi-cash-lock",
  floorplan: "mdi-floor-plan",
  folder: "mdi-folder-outline",
  folder_add: "mdi-folder-plus-outline",
  folder_read_only: "mdi-folder-eye-outline",
  folder_upload: "mdi-folder-upload-outline",
  fuel: "mdi-gas-station",
  fullscreen: "mdi-fullscreen",
  fullscreen_exit: "mdi-fullscreen-exit",
  glass: "mdi-checkbox-multiple-blank",
  glass_broken: "mdi-image-broken-variant",
  goal: "mdi-flag-checkered",
  gps: "mdi-crosshairs-gps",
  grid: "mdi-view-grid",
  hardware: "mdi-key-chain-variant",
  hardware_issue: "mdi-key-alert-outline",
  heart: "mdi-heart",
  held_pay_from: "mdi-piggy-bank-outline",
  held_pay_to: "mdi-piggy-bank",
  help: "mdi-help-circle",
  historic: "mdi-pillar",
  history: "mdi-history",
  holding: "mdi-cancel",
  home: "mdi-home",
  homeowner: "mdi-home-account",
  id: "mdi-identifier",
  image: "mdi-image",
  image_off: "mdi-image-off",
  images: "mdi-image-multiple",
  income: "mdi-cash-plus",
  info: "mdi-information",
  inspection: "mdi-eye-check",
  inspection_needed: "mdi-eye-check-outline",
  installation: "mdi-hammer-wrench",
  inventory: "mdi-package-variant",
  inventory_count: "mdi-package-variant-closed-check",
  inventory_count_active: "mdi-package-variant-closed",
  inventory_count_complete: "mdi-package-variant-closed-check",
  invert: "mdi-select-inverse",
  invoice: "mdi-invoice-text-outline",
  issue: "mdi-alert-rhombus",
  item_location: "mdi-map-marker",
  items: "mdi-checkbox-multiple-blank-outline",
  keyboard: "mdi-keyboard-variant",
  knowledge: "mdi-head-lightbulb",
  label: "mdi-label",
  labor_materials: "mdi-screw-flat-top",
  last: "mdi-page-last",
  lead_time: "mdi-timelapse",
  less: "mdi-unfold-less-horizontal",
  liability: "mdi-piggy-bank",
  library: "mdi-folder-multiple",
  link: "mdi-link",
  list: "mdi-format-list-bulleted",
  loaded: "mdi-truck-check-outline",
  loading: "mdi-truck-delivery",
  loading_ready: "mdi-truck-delivery-outline",
  location: "mdi-map-marker",
  lock: "mdi-lock",
  lock_issue: "mdi-lock-alert-outline",
  log_out: "mdi-lock",
  logs: "mdi-script-text",
  lost: "mdi-cash-off",
  maintenance: "mdi-engine",
  man_hours: "mdi-account-clock",
  management: "mdi-account-supervisor",
  // A service issue's type; a placeholder icon, to be replaced
  manufacturing_defect: "mdi-factory",
  magnet: "mdi-magnet",
  map: "mdi-map",
  map_multiple: "mdi-map-marker-multiple",
  margin: "mdi-cash-plus",
  married: "mdi-ring",
  meeting: "mdi-account-multiple",
  menu: "mdi-menu",
  menu_dots: "mdi-dots-vertical",
  message: "mdi-message",
  mileage: "mdi-counter",
  misc_item: "mdi-label-variant",
  missing: "mdi-alert-circle-outline",
  more: "mdi-unfold-more-horizontal",
  multifamily: "mdi-hexagon-multiple",
  new: "mdi-new-box",
  new_home: "mdi-home",
  no_material: "mdi-table-cancel",
  non_posting: "mdi-bank-off",
  notification: "mdi-bell",
  notification_active: "mdi-bell-ring",
  number: "mdi-pound",
  office: "mdi-office-building",
  old_schedule: "mdi-calendar-blank-outline",
  on_hold: "mdi-pause-circle-outline",
  ooo: "mdi-calendar-remove",
  open: "mdi-alert-decagram",
  open_external: "mdi-open-in-new",
  order: "mdi-text-box-outline",
  person: "mdi-account",
  person_off: "mdi-account-off",
  report: "mdi-file-chart",
  orders: "mdi-text-box-multiple-outline",
  other_asset: "mdi-cash-lock-open",
  packing_slip: "mdi-text-box-check",
  page_break: "mdi-format-page-break",
  palette: "mdi-palette-outline",
  paid: "mdi-cash-check",
  paying: "mdi-cash",
  payroll: "mdi-account-cash",
  pending: "mdi-timer-sand",
  pending_date: "mdi-calendar-question",
  pending_sale: "mdi-cash-clock",
  percent: "mdi-percent",
  performance_metrics: "mdi-chart-bar",
  personal: "mdi-account-lock-outline",
  phone: "mdi-phone",
  pickup: "mdi-package-up",
  polygon: "mdi-vector-polygon",
  poor_operation: "mdi-window-shutter-alert",
  position: "mdi-card-account-details",
  price: "mdi-currency-usd",
  print: "mdi-printer",
  production: "mdi-factory",
  project: "mdi-home-city",
  punchout: "mdi-boxing-glove",
  purchaser: "mdi-text-box-outline",
  qr_code: "mdi-qrcode",
  qualified: "mdi-check-decagram",
  quality_control: "mdi-certificate",
  quantity: "mdi-checkbox-multiple-blank",
  quote: "mdi-file-table-box",
  quotes: "mdi-file-table-box-multiple",
  reason: "mdi-help-box",
  reassign: "mdi-account-switch-outline",
  receipt: "mdi-receipt",
  received: "mdi-call-received",
  receiving: "mdi-package-down",
  recent: "mdi-history",
  redo: "mdi-redo",
  referred: "mdi-call-made",
  refresh: "mdi-refresh",
  refund: "mdi-cash-refund",
  relocate: "mdi-arrow-right-bold-box",
  remodel: "mdi-home-edit",
  reply: "mdi-reply",
  reply_all: "mdi-reply-all",
  reschedule: "mdi-calendar-arrow-right",
  reset: "mdi-undo",
  restore: "mdi-restore",
  resume: "mdi-play-circle-outline",
  retail: "mdi-store",
  return: "mdi-home-import-outline",
  review_pending: "mdi-check-decagram-outline",
  reviewed: "mdi-check-decagram",
  role: "mdi-badge-account-horizontal",
  safety: "mdi-hard-hat",
  sale: "mdi-alpha-s-circle",
  sales: "mdi-alpha-s-box",
  sales_lead: "mdi-alpha-s-circle-outline",
  sales_report: "mdi-chart-box",
  sales_team: "mdi-account-group",
  sales_team_inactive: "mdi-account-group-outline",
  sales_tools: "mdi-trending-up",
  sample: "m 5,4 h 4 v 1 c 4,4 6,6 10,10 h 1 v 4 H 5 V 4 m 4,11 h 8 L 9,7 Z",
  scheduling: "mdi-timetable",
  screens: "mdi-cards-outline",
  scroll_top: "mdi-arrow-collapse-up",
  scroll_bottom: "mdi-arrow-collapse-down",
  seal_failure: "mdi-water-alert",
  search: "mdi-magnify",
  seen: "mdi-email-open",
  seen_all: "mdi-email-open-multiple",
  select: "mdi-checkbox-marked-outline",
  select_tool: "mdi-select",
  send: "mdi-send",
  sent: "mdi-send-check",
  service: "mdi-wrench",
  settings: "mdi-cog",
  share: "mdi-share-variant",
  signature: "mdi-signature",
  skip: "mdi-skip-next",
  sna_archive: "img:/icons/sna-logo.svg",
  snooze: "mdi-alarm-snooze",
  sold: "mdi-cash-check",
  sort: "mdi-sort",
  sort_alpha: "mdi-sort-alphabetical-ascending",
  sort_alpha_reverse: "mdi-sort-alphabetical-descending",
  sort_date: "mdi-sort-calendar-ascending",
  sort_date_reverse: "mdi-sort-calendar-descending",
  sort_location: "mdi-map-marker-down",
  sort_location_reverse: "mdi-map-marker-up",
  sort_number: "mdi-sort-numeric-ascending",
  sort_number_reverse: "mdi-sort-numeric-descending",
  sort_status: "mdi-timeline-plus",
  sort_status_reverse: "mdi-timeline-minus",
  sort_time: "mdi-sort-clock-ascending",
  sort_time_reverse: "mdi-sort-clock-descending",
  status: "mdi-timeline-question",
  success: "mdi-check-circle",
  sum: "mdi-sigma",
  task: "mdi-clipboard-check-outline",
  task_done: "mdi-clipboard-check",
  target_contact: "mdi-target-account",
  tax: "mdi-cash-plus",
  temporary_destination: "mdi-routes-clock",
  terms: "mdi-handshake",
  text: "mdi-text",
  time: "mdi-clock-outline",
  time_clock: "mdi-briefcase-clock",
  timeline: "mdi-chart-timeline",
  tips_tricks: "mdi-auto-fix",
  to: "mdi-chevron-right",
  today: "mdi-calendar-today",
  tomorrow: "mdi-calendar-arrow-right",
  top_customer: "mdi-crown",
  transaction: "mdi-bank-transfer",
  trophy: "mdi-trophy",
  trophy_outline: "mdi-trophy-outline",
  type: "mdi-help-box",
  // The receiving icon (mdi-package-down) with its down-arrow swapped for a
  // question mark: material that arrived but we don't know what it belongs to.
  //
  // Inline SVG path data rather than "img:" -- Quasar renders "img:" as an
  // <img>, which cannot inherit currentColor and would paint black on the
  // green tile, whereas path data becomes a real <svg> that takes the parent's
  // colour.
  //
  // Must stay ONE path. Quasar splits on "&&" into separate <path> elements,
  // and separate elements each fill independently, which loses the nonzero
  // winding that cuts the lid line and the question mark out of the box. A
  // three-path version of this icon rendered as a solid white square.
  unassigned:
    "M 6 3 C 5.5300005 3 5.1198435 3.2107816 4.8398438 3.5507812 L 3.4609375 5.2304688 C 3.1709378 5.5704684 3 6.0000005 3 6.5 L 3 19 C 3 20.104568 3.8954316 21 5 21 L 19 21 C 20.104568 21 21 20.104568 21 19 L 21 6.5 C 21 6.0000005 20.829062 5.5704684 20.539062 5.2304688 L 19.150391 3.5507812 C 18.880391 3.2107816 18.47 3 18 3 L 6 3 z M 5.9296875 4 L 17.929688 4 L 18.869141 5 L 5.1191406 5 L 5.9296875 4 z M 12 7.171875 C 14.209137 7.171875 16 8.9627382 16 11.171875 C 16 13.671872 13 13.921877 13 16.171875 L 11 16.171875 C 11 12.921878 14 13.171873 14 11.171875 C 14 10.067307 13.104568 9.171875 12 9.171875 C 10.895432 9.171875 10 10.067307 10 11.171875 L 8 11.171875 C 8 8.9627382 9.7908632 7.171875 12 7.171875 z M 11 17.171875 L 13 17.171875 L 13 19.171875 L 11 19.171875 L 11 17.171875 z",
  unarchive: "mdi-archive-arrow-up",
  undelivered: "mdi-send-circle-outline",
  undo: "mdi-undo",
  undone: "mdi-check-outline",
  unknown: "mdi-help-circle",
  unloading: "mdi-arrow-left-bold-box-outline",
  unlock: "mdi-lock-open-variant",
  unpaid: "mdi-cash-remove",
  unseen: "mdi-email",
  unsent: "mdi-send-outline",
  update: "mdi-cached",
  upload: "mdi-file-upload",
  whats_new: "mdi-party-popper",
  user: "mdi-account-circle",
  user_disable: "mdi-account-cancel",
  user_edit: "mdi-account-edit",
  user_enable: "mdi-account-check",
  vehicle: "mdi-car",
  vehicle_delivery: "mdi-truck",
  vehicle_personal: "mdi-car-side",
  vehicle_service: "mdi-van-utility",
  vehicles: "mdi-car-multiple",
  vendor: "mdi-factory",
  vertex_remove: "mdi-vector-point-minus",
  view: "mdi-eye",
  video: "mdi-video-outline",
  visible: "mdi-eye",
  visible_off: "mdi-eye-off",
  warehouse: "mdi-warehouse",
  warning: "mdi-alert",
  wholesale: "mdi-handshake-outline",
  window: "mdi-window-closed-variant",
  withdraw: "mdi-bank-transfer-out",
  work: "mdi-briefcase",
  zoom_fit: "mdi-fit-to-page-outline",
  zoom_fit_height: "mdi-arrow-expand-vertical",
  zoom_fit_width: "mdi-arrow-expand-horizontal",
  zoom_in: "mdi-magnify-plus",
  zoom_out: "mdi-magnify-minus",
  zone: "mdi-vector-square",
};
